export enum ProfileShipmentViewMode {
  To = 'TO',
  Load = 'LOAD',
}
